import { render, staticRenderFns } from "./rfp-po.vue?vue&type=template&id=46c16d95&"
import script from "./rfp-po.vue?vue&type=script&lang=js&"
export * from "./rfp-po.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports